import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/healthtech/page.tsx");
